var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "bk-ai-hint",
      attrs: {
        type: "button",
        "aria-label": _vm.$translate("Ceres::Template.imageAiHintLabel"),
        "aria-controls": "aside_ai-hint",
      },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.openHint.apply(null, arguments)
        },
        mousedown: function ($event) {
          $event.stopPropagation()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
        },
        keydown: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("img", {
        staticClass: "bk-ai-hint__icon",
        attrs: {
          src: "https://cdn.bio-kinder.de/frontend/images/biokindertheme/icons/ai-info-w.svg",
          alt: "",
          "aria-hidden": "true",
          width: "66",
          height: "17",
          decoding: "async",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }